import { MediasPublicModels } from '../medias';
import { MediaLocation } from '../medias/domain/models/medias.models';
import { ProductPublicModels } from '../product/public.api';

import { getCarouselImagesUseCase, getImageForProductViewUseCase, getMultipleMediasUseCase } from './application/use-cases/product-images.use-case';

export const ProductImagePublicFunctions = {
    getImageForProductView: ({
        color,
        productImagesLocation,
        locationDefault,
        imageType,
        imageTypeAlternative,
        defaultImageType,
        options,
    }: {
        color: ProductPublicModels.PublicProductColor;
        productImagesLocation: MediasPublicModels.PublicMediaLocation;
        locationDefault: MediaLocation;
        imageType: string;
        imageTypeAlternative: string;
        defaultImageType: string;
        options: {
            discardDoubleVideo?: boolean;
            secondaryImage?: boolean;
            set?: number;
        };
    }) => getImageForProductViewUseCase({
        color,
        productImagesLocation,
        locationDefault,
        imageType,
        imageTypeAlternative,
        defaultImageType,
        options,
    }),
    getCarouselImages: ({
        color,
        location,
        imageType,
        image,
    }: {
        color: ProductPublicModels.PublicProductColor;
        location: MediaLocation;
        imageType: string;
        image: MediasPublicModels.PublicMediaResolved;
    }) => getCarouselImagesUseCase({
        color,
        location,
        imageType,
        image,
    }),
    getMultipleMedias: ({
        color,
        mediaType,
        totalMedias,
    }: {
        color: ProductPublicModels.PublicProductColor;
        mediaType: string;
        totalMedias: number;
    }) => getMultipleMediasUseCase({
        color,
        mediaType,
        totalMedias,
    }),
};
